export default __webpack_public_path__ + "static/what-are-we-doing-2-e763dd80823e9f78f2eec83b21f959d1.png";